// ScrollToTop — слушает изменения pathname и прокручивает контентный
// контейнер админ-панели в самый верх при переходе между страницами.
//
// В админ-панели window сам не скроллится — прокручивается внутренний
// .contentWrapper (см. Main.module.css), поэтому скроллить нужно именно его
// (получаем через targetRef). На всякий случай заодно скроллим window.scrollTo,
// чтобы покрыть мобильные адресные бары и edge-кейсы.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ targetRef }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Внутренний скролл-контейнер
        const el = targetRef && targetRef.current;
        if (el) {
            try { el.scrollTo({ top: 0, left: 0, behavior: 'auto' }); }
            catch { el.scrollTop = 0; }
        }
        // На всякий случай — window
        try { window.scrollTo({ top: 0, left: 0, behavior: 'auto' }); }
        catch { window.scrollTo(0, 0); }
    }, [pathname, targetRef]);

    return null;
};

export default ScrollToTop;
